interface ShapeProps {
  kind: 'circle' | 'squircle' | 'pill' | 'blob';
  color: string;
  size?: number;
}

export function Shape({ kind, color, size = 32 }: ShapeProps) {
  if (kind === 'circle') {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
        }}
      />
    );
  }
  if (kind === 'squircle') {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: size / 3,
          background: color,
          flexShrink: 0,
        }}
      />
    );
  }
  if (kind === 'pill') {
    return (
      <div
        style={{
          width: size * 1.6,
          height: size * 0.75,
          borderRadius: 999,
          background: color,
          flexShrink: 0,
        }}
      />
    );
  }
  return (
    <svg
      width={size * 1.25}
      height={size}
      viewBox="0 0 44 38"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path
        d="M9 6 C 16 -2, 32 0, 40 10 C 46 20, 38 34, 26 36 C 14 38, 2 30, 2 20 C 2 12, 4 10, 9 6 Z"
        fill={color}
      />
    </svg>
  );
}
